<div class="marina-selection-dialog">
  <div class="dialog-header">
    <h3>Select Marina</h3>
    <button mat-icon-button (click)="onCancel()" class="close-btn" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="marina-list">
      <button
        *ngFor="let marina of accessibleMarinas"
        class="marina-item"
        [class.selected]="currentMarinaId === marina.id"
        (click)="selectMarina(marina.id)"
        type="button">
        <div class="marina-info">
          <div class="marina-name">{{ marina.name }}</div>
          <div class="marina-badge" *ngIf="marina.isPrimary">Primary</div>
        </div>
        <mat-icon *ngIf="currentMarinaId === marina.id" class="check-icon">check</mat-icon>
      </button>
    </div>
  </div>
</div>
